
import { css } from 'lit';
export default css`
:host{
  display:inline-block;
}

.tag{
  display:inline-flex;
  align-items:center;
  gap:var(--spacing-2);
  text-transform:uppercase;
  font-weight:var(--fw-medium);
  font-size:var(--fs-eyebrow-mobile);
  line-height:var(--lh-eyebrow-mobile);
  font-family:var(--ff-body);
  letter-spacing:var(--ls-eyebrow);
}

.tag.outlined{
  padding:calc(var(--spacing-2) - 2px) var(--spacing-4);
  border:2px solid var(--purple-indigo-light);
  border-radius:100px;
  background-color:inherit;
}

.tag.secondary{
  background-color:var(--neutral-light);
  background-color:var(--tag-bg-override, var(--neutral-light));
  color:var(--primary-eggplant);
  border-radius:0px 100px 100px 0px;
  padding:var(--spacing-3) var(--spacing-4) var(--spacing-3) var(--spacing-3);
}

@media (min-width: 768px){
  .tag{
    font-size:var(--fs-eyebrow);
    font-size:var(--font-size-pc-tag, var(--fs-eyebrow));
    line-height:var(--lh-eyebrow);
  }

  .tag.outlined{
    padding:var(--spacing-2) var(--spacing-4);
  }
}
`;